// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"252":"3940311c","257":"d9f70525","548":"994c148d"}[chunkId] + ".chunk.css";
};